/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import type { FC } from 'react'
import cn from 'classnames'
import { Edit, MapMarker } from 'components/icons'
import { Button } from 'components/ui'
import type { AddressCardProps } from '.'
import s from './address-card.module.css'

const AddressCard: FC<AddressCardProps> = ({ customer, className, address, active, onSelect, onEdit }) => {
  const {
    recipient,
    zipCode,
    street,
    neighborhood,
    complement,
    number,
    type,
    city: { name, district },
  } = address

  return (
    <div className={cn(s.root, active && s.active, className)} onClick={() => onSelect(address)}>
      <span className={s.tag}>{type}</span>
      <MapMarker className={s.icon} />
      <div className={s.content}>
        <div className={s.lineOne}>
          <strong>{recipient || customer.name}</strong>
          <br />
          {street.slice(0, 10)}
          {street.length > 10 && '...'}, n.: {number} - {neighborhood}
          {/* {street} - {neighborhood} */}
        </div>
        <div className={s.lineTwo}>
          {name} - {district}, {zipCode}
        </div>
        <div className={s.lineThree}>{complement}</div>
      </div>
      <div className={s.controls}>
        <Button variant="ghost" onClick={() => onEdit(address)}>
          <Edit />
          &nbsp;editar
        </Button>
      </div>
    </div>
  )
}

export default AddressCard
